import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { STATES } from "../constants/states";

export function RegionSelect({ value, onChange, testId = "region-select" }) {
  return (
    <Select value={value || undefined} onValueChange={onChange}>
      <SelectTrigger data-testid={testId} className="brut-input h-[52px] rounded-none">
        <SelectValue placeholder="Choose your state" />
      </SelectTrigger>
      <SelectContent className="rounded-none border-2 border-[#FF4D00] max-h-72">
        {STATES.map(([code, name]) => (
          <SelectItem key={code} value={code} data-testid={`region-option-${code}`}>{name}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
